module.exports = __webpack_public_path__ + "img/10062023.c3604ea8.png";